<style src="./NotFound.scss" lang="scss" scoped></style>


<template>
  <div class="not-found">
    <h2>404 Page not found</h2>
  </div>
</template>
<script>
export default { name: 'NotFound' };
</script>
